<template>
    <transition
        appear
        name="fade"
        :enter-active-class="theme.fadeEnterActive"
        :enter-class="theme.fadeEnter"
        :enter-to-class="theme.fadeEnterTo"
        :leave-active-class="theme.fadeLeaveActive"
        :leave-class="theme.fadeLeave"
        :leave-to-class="theme.fadeLeaveTo"
    >
        <div v-if="active" :class="theme.wrapper" @click.stop="handleClose">
            <div :class="classes" @mouseleave="handleBlur" @mouseenter="handleFocus">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>
<script>
    import theme from './modal.scss';

    export default {
        name: 'modal',
        props: {
            autoWidth: Boolean,
            wideWidth: Boolean,
            active: Boolean,
        },
        data() {
            return {
                theme,
                isOver: false,
            }
        },
        computed: {
            classes() {
                return {
                    [theme.modal]: true,
                    [theme.isAutoWidth]: this.autoWidth,
                    [theme.isWideWidth] : this.wideWidth
                }
            },
        },
        methods: {
            handleClose() {
                if (!this.isOver) {
                    this.$emit('close');
                }
            },
            handleFocus() {
                this.isOver = true;
            },
            handleBlur() {
                this.isOver = false;
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Modal.vue?81ceb808